import React from "react";
import clsx from "clsx";
import MuiDialogActions from "@mui/material/DialogActions";

import { useStyles } from "./DialogActions.styles";
import { DialogActionsProps } from "./DialogActions.types";

function DialogActions(props: DialogActionsProps) {
  const { extra, className, ...other } = props;

  const classes = useStyles(props);

  return (
    <div className={clsx(classes.root, className)}>
      {extra && <div className={classes.extra}>{extra}</div>}
      <MuiDialogActions {...other} className={classes.actions} />
    </div>
  );
}

export default DialogActions;
